import React from "react";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-purple-100 flex flex-col items-center justify-center p-6 font-sans">
      <div className="max-w-md w-full bg-white rounded-xl shadow-lg overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-purple-400 to-purple-600 py-8 px-6 text-center">
          <h1 className="text-3xl font-bold text-white">404</h1>
          <p className="text-purple-100 mt-2">Page Not Found</p>
        </div>

        {/* Content */}
        <div className="p-8 text-center">
          <div className="mb-6">
            <svg
              className="w-24 h-24 mx-auto text-purple-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>

          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            Oops! Lost in the Digital Space
          </h2>
          <p className="text-gray-600 mb-8">
            The page you're looking for doesn't exist or has been moved. Let's
            get you back on track.
          </p>

          {/* <button
            onClick={() => navigate('/')}
            className="bg-gradient-to-r from-purple-500 to-purple-700 hover:from-purple-600 hover:to-purple-800 text-white font-semibold py-3 px-8 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
          >
            Return to Home
          </button> */}
        </div>

        {/* Footer */}
        <div className="bg-purple-50 text-center py-4 text-sm text-gray-600">
          <p>
            Need help?{" "}
            <a
              href="mailto:support@digikorejingles.com"
              className="text-purple-600 font-medium"
            >
              Contact support
            </a>
          </p>
          <p className="mt-1">
            © {new Date().getFullYear()} mytruestrength.com All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
